import { Observable } from 'rxjs/Rx'

import { IOperationProcessor } from './operation-processors'
import { BaseModel } from '../../../models'

export abstract class OperationServiceAdapter<T extends BaseModel> {
  constructor(
    private _operationProcessor: IOperationProcessor,
    private _modelType: {new(): T}) {}

  protected callGetOperation(operationName: string, params?: {}, includes?: string[], filters?: {}): Observable<T|T[]> {
    return this._operationProcessor.process<T>({
      httpMethod: 'get', returnType: this._modelType, operation: operationName,
      params: params, filters: filters, includes: includes
    })
  }

  protected callPostOperation(operationName: string, params?: {}, includes?: string[], filters?: {}): Observable<T|T[]> {
    return this._operationProcessor.process<T>({
      httpMethod: 'post', returnType: this._modelType, operation: operationName,
      params: params, filters: filters, includes: includes
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/operation/operation-service-adapter.ts